import {Component, Input, OnInit} from '@angular/core';
import {OrderDetails} from "../../../../core/models/order-details";
import {BudgetType} from "../../../../core/helpers/constants";

@Component({
  selector: 'app-benefit-details-payment-history',
  templateUrl: './benefit-details-payment-history.component.html',
  styleUrls: ['./benefit-details-payment-history.component.scss']
})
export class BenefitDetailsPaymentHistoryComponent implements OnInit {

  @Input() orderDetails: OrderDetails;
  @Input() benefitPrice: number;

  constructor() { }

  ngOnInit(): void {
  }

  protected readonly BudgetType = BudgetType;
}
